import QuickShopClass from './product-quickshop';
import { Constants } from './quickshop-constants';
import { QuickShopSideBarComponent } from './sidebar-component';
import { isMobile } from '../../utils/helpers';

export const QuickShopMainVueInstance = {
  el: Constants.els.quickShopVueComponent,
  components: {
    'quickshop-sidebar': QuickShopSideBarComponent,
  },
  data: {
    isActive: false,
    product: {},
    xsellOptions: {
      // defaults
      headerText: 'Quick Shop',
      themeClass: '',
      isXsellTriggered: false
    },
  },
  created() {
    document.addEventListener('quickshop:close', () => {
      if (this.isActive) {
        this.isActive = false;
      }
    });
  },
  
  beforeDestroy() {
    document.removeEventListener('quickshop:close', () => {
      if (this.isActive) {
        this.isActive = false;
      }
    });
  },
  updated() {
    if (this.isActive) {
      document.body.classList.add('scroll-locked');
      document.documentElement.classList.add('scroll-locked');
      this.setContentInnerHeight();
    } else {
      document.body.classList.remove('scroll-locked');
      document.documentElement.classList.remove('scroll-locked');
    }
  },
  methods: {
    toggleQuickShopOpen() {
      this.isActive = !this.isActive;
    },
    closeQuickShop() {
      this.isActive = false;
    },
    async addToQuickshop(handle, isSample = false, sampleData = null, options = {}) {
      const productJSON = await QuickShopClass.getInstance().addToQuickshop(
        handle,
        isSample,
        sampleData,
        options
      );
      this.product = productJSON;
    },
    setContentInnerHeight() {
      // Same CSS Variables
      let sidebarInnerContentMobileHeight;
      const $padding = '24px';
      const quickshopHeaderHeight = '50px';
      const quickshopFooterHeight = $('.quickshop__footer').outerHeight();
      isMobile()
        ? (sidebarInnerContentMobileHeight = '100%')
        : (sidebarInnerContentMobileHeight = '100%');

      const height = `calc(${sidebarInnerContentMobileHeight} - ${$padding} - ${quickshopFooterHeight}px - ${quickshopHeaderHeight})`;
      $('.quickshop__content').css({ height: height });
    },
  },
};
